
import { DisplayConfig } from "../../components/ViewConfig/ConfigProvider"
import { isChartActive, StatsCollection }from "./chartIsActive"
import { DataPoint } from "../../Pages/Historic"


export function determineYaxisOrientation(index:number, numActive:number):'right'|'left'{
    if (index==0){
        return 'left'
    }
    if(index==numActive-1 ){
        return 'right'
    }
    return 'left'
}

export function isAxisHidden(index:number, numActive:number):boolean{
    if (index == 0 || index==numActive-1){
        return false
    }
    return true
}
export function numActiveCharts(config:DisplayConfig, stats:StatsCollection):number{
    let activeCharts = 0
    Array.from(config.charts).forEach((chart)=>{
        if(isChartActive(chart[1], stats)){
            activeCharts++
        }
    })
    return activeCharts   
}
export function createYAxis(data:DataPoint[]){
    const first = data[0]['timestamp']
    const last  = data[data.length]['timestamp']
}
function extractDateStringFromParts(parts:Intl.DateTimeFormatPart[]):string{
    var hours:string
    var minutes:string
    parts.forEach((part)=>{
        if (part.type == 'hour'){
            hours = part.value
        }
        if (part.type =='minute'){
            minutes = part.value
        }
    })
    return `${hours}:${minutes}`
}
function extractLabelDateStringFromParts(parts:Intl.DateTimeFormatPart[]):string{
    var hours:string
    var minutes:string
    var seconds:string
    parts.forEach((part)=>{
        if (part.type == 'hour'){
            hours = part.value
        }
        if (part.type =='minute'){
            minutes = part.value
        }
        if (part.type =='second'){
            seconds = part.value
        }
    })
    return `${hours}:${minutes}:${seconds}`
}
export function TickFormatTZ(value:number, tz:string):string{
    //console.log("yaxis timezone:",tz)
    //converts epoch seconds to epoch miliseconds
    if (value<100000000){
         value = value *1000
    }
    const dateFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hourCycle: "h24",
    hour:"2-digit",
    minute:"2-digit",
    second:"2-digit"
    });
    let date = new Date(value);
    const parts = dateFormat.formatToParts(date)
    return extractDateStringFromParts(parts)
    
}

export function TooltipLabelFormatWithTimezone(value:number, tz:string){
    //console.log("tooltip timezone:",tz)
    const dateFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hourCycle: "h24",
    hour:"2-digit",
    minute:"2-digit",
    second:"2-digit"
    });
    let date = new Date(value);
    const parts = dateFormat.formatToParts(date)
    return extractLabelDateStringFromParts(parts)
}